<template>
  <div id="app">
    <div id="header">
      <logo id="logo" />
      <div id="divider"></div>
      <img
        src="./assets/header-left2.jpg"
        alt="Milford Adams giving speech"
        id="header-left"
      />
      <img
        src="./assets/header-right.jpg"
        alt="Milford Adams giving speech"
        id="header-right"
      />
      <navBar id="navBar" v-if="!!isBigScreen" />
      <!-- <mobileNavBar id="mobileNavBar" v-if="!isBigScreen" /> -->
    </div>
    <router-view />
  </div>
</template>

<script>
import navBar from "./components/navBar.vue";
import mobileNavBar from "./components/mobileNavBar.vue";
import logo from "./components/logo.vue";

export default {
  name: "app",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    navBar: navBar,
    // eslint-disable-next-line vue/no-unused-components
    mobileNavBar: mobileNavBar,
    logo: logo,
  },
  data: function () {
    return {
      windowWidth: 0,
    };
  },
  created: function () {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    isBigScreen() {
      if (this.windowWidth > 980) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}

#logo {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 10px;
  padding-right: 20px;
  display: inline-block;
  z-index: 5;
}

#divider {
  position: absolute;
  top: -35px;
  left: 425px;
  display: inline-block;
  width: 400px;
  height: 500px;
  z-index: -4;
  transform: rotate(45deg);
  transform-origin: 0% 0%;
  background-color: white;
}

#divider::before {
  content: "";
  position: absolute;
  margin-left: -50%;
  width: 100%;
  padding: 3px 0 3px;
  background: linear-gradient(to right, #ff6600, #4d94ff);
  z-index: 2;
}

#header-left {
  position: relative;
  left: 70px;
  height: 240px;
  filter: grayscale(0.8);
  z-index: -5;
}

#header-right {
  position: absolute;
  top: 0;
  right: 0;
  height: 240px;
  filter: grayscale(0.8);
  border-bottom-left-radius: 35%;
}
</style>
